interface IQuestionChoice {
  id: string | number;
  number_value?: number;
  order: number;
  question: number;
  request_details: boolean;
  text_value?: string;
}

// Values example:
// id: 41
// number_value: null
// order: 0
// question: 79
// request_details: false
// text_value: "Drop down 1"

class QuestionChoice {
  constructor(
    {
      id,
      number_value,
      order,
      question,
      request_details,
      text_value,
    }: IQuestionChoice,
    isNew = true
  ) {
    this.id = id ?? parseInt(Math.random() * 1000000000000000).toString()
    this.original_id = this.id?.toString()
    this.number_value = number_value ?? null
    this.order = order || 0
    this.question = question
    this.request_details = request_details || false
    this.text_value = text_value
    this.isNew = isNew
    this.integration_value = text_value
  }
}

export default QuestionChoice
